import { getNextSibling } from "./Utils"
import IAFilterPost from "./Classes/IAFilterPost";

let timer
let time = 0

if (!!document.querySelector('.ia-block-posts__filters__inner-container')) {
    document.querySelectorAll('.ia-block-posts__filters__inner-container').forEach(block => {
        const input = document.querySelector('#pageNumber')
        let postsListing = getNextSibling(block, '.ia-block-posts__list')
        let postsFilters = block.querySelector('.ia-block-posts-filters__list')
        let filters = {
            tag: []
        }
        postsFilters.querySelectorAll('input[type="checkbox"][name="category_filter[]"]').forEach(choice => {
            choice.addEventListener('change', e => {
                let choices = filters.tag
                if (e.target.checked === true) {
                    filters.tag.push(e.target.value)
                } else {
                    filters.tag.splice(filters.tag.indexOf(e.target.value), 1)
                }

                if(timer != undefined) {
                    clearInterval(timer)
                    time = 0
                }
                setTimeout(updateNews(choices, 1), 200)
                input.value = 1
            })
        })

        input.addEventListener('keypress', function(event){
            if (event.key === "Enter") {
                if(Number(input.value) <= Number(document.querySelector('.pagination-max').textContent) && Number(input.value) > 0){
                    getNews(filters.tag, Number(input.value))
                }
            }
        })

        document.querySelector('.pagination-next button').addEventListener('click', function(e){
            getNews(filters.tag, Number(document.querySelector('.ia-block-posts').dataset.page)+1)
            input.value = Number(document.querySelector('.ia-block-posts').dataset.page)
        })
        document.querySelector('.pagination-prev button').addEventListener('click', function(e){
            getNews(filters.tag, Number(document.querySelector('.ia-block-posts').dataset.page)-1)
            input.value = Number(document.querySelector('.ia-block-posts').dataset.page)
        })

        function updateNews(choices, page_to_load) {
            timer = setInterval(() => {
                time = time + 100
                if (time === 800) {
                    getNews(choices, page_to_load)
                    clearInterval(time)
                }
            }, 100)
        }

        function getNews(choices, page_to_load){
            new IAFilterPost({
                post_type: 'posts', 
                item: document.querySelector('.ia-block-posts__list-item'), 
                page_to_load: page_to_load,
                per_page: Number(document.querySelector('.ia-block-posts__list').dataset.perpage),
                maxpage: Number(document.querySelector('.ia-block-posts__list').dataset.maxpages),
                lang: document.querySelector('html').lang,
                image:'.ia-block-post__featured-image img',
                title: '.ia-block-post__title a',
                date: '.ia-block-post__date',
                tag: choices,
                list: document.querySelector('.ia-block-posts__list'),
                label: '.ia-block-post__tag'
            })
        }
    })
}
